import { Component, OnInit,Inject  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TextEditorDialogData {
  title: string;
  label: string;
  value: string;
  maxLength?: number;
}

@Component({
  selector: 'app-text-editor-dialog',
  templateUrl: './text-editor-dialog.component.html',
  styleUrls: ['./text-editor-dialog.component.scss']
})
export class TextEditorDialogComponent  {

   textValue: string = '';
  maxLength: number = 1000;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TextEditorDialogData,
              private dialogRef: MatDialogRef<TextEditorDialogComponent>) {
    this.maxLength = data.maxLength ?? 1000;
    this.textValue = (data.value || '').slice(0, this.maxLength);
  }

   save(): void {
    this.textValue = (this.textValue || '').slice(0, this.maxLength).trim();
    this.dialogRef.close(this.textValue);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }

  get remainingChars(): number {
    return this.maxLength - (this.textValue?.length || 0);
  }

}
